import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));
